import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _objectSpread2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/material';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_02 } from '../styles/typography/typography';
import { PROMETHEAN_TEXT_HEADER, PROMETHEAN_TEXT, PROMETHEAN_NEUTRAL_MID_GREY } from '../styles/colors/colors';
import { EMBERS_HEADER_HEIGHT_MOBILE } from '../header/headerStyles';
export var ROOT_PREFIX = 'EmbersMobileNavBarContainer';
export var EMBERS_NAVIGATION_HEIGHT_MOBILE = 48;
export var StyledMobileNavBarContainer = styled('div')({
  '.MuiAccordion-root': {
    zIndex: 201,
    position: 'fixed',
    width: '100%',
    top: EMBERS_HEADER_HEIGHT_MOBILE,
    boxShadow: 'none',
    '.MuiAccordionSummary-root': {
      padding: 12,
      '&.Mui-expanded': {
        minHeight: EMBERS_NAVIGATION_HEIGHT_MOBILE
      },
      '.MuiAccordionSummary-content': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, (_objectSpread2 = {
        alignItems: 'center',
        margin: '0 12px 0 0',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      }, _defineProperty(_objectSpread2, ".".concat(ROOT_PREFIX, "-selected-icon"), {
        display: 'flex',
        alignItems: 'center',
        marginRight: 12,
        '& *': {
          width: 24,
          height: 24,
          fontSize: 24
        }
      }), _defineProperty(_objectSpread2, ".".concat(ROOT_PREFIX, "-selected-label"), {
        color: PROMETHEAN_TEXT_HEADER,
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }), _objectSpread2)),
      '.icon-expand-more': {
        color: PROMETHEAN_TEXT
      }
    },
    '.MuiCollapse-root': {
      background: PROMETHEAN_NEUTRAL_MID_GREY,
      '.MuiAccordionDetails-root': {
        padding: '16px 16px 32px 16px',
        '.MuiTreeItem-content': {
          marginBottom: 4
        }
      }
    },
    '>.MuiCollapse-root': {
      '&>.MuiCollapse-wrapper': {
        '.MuiAccordion-region': {
          overflow: 'auto',
          maxHeight: 'calc(100vh - 104px)',
          position: 'relative'
        }
      },
      position: 'relative'
    },
    '.EmbersNav-item': {
      maxWidth: '100% !important'
    }
  },
  '.MuiBackdrop-root': {
    zIndex: 200
  }
});